export default __webpack_public_path__ + "static/media/Investigations.8544032d.svg";